import angular from "angular";
import MeradloService from "./MeradloService";
import { EditCtrl } from "../Editor";
import MeradloEditCtrl from "./MeradloEditCtrl";
import MeradloImportCtrl from "./MeradloImportCtrl";
import ListViewCtrl from "../util/ListViewCtrl";

export default angular
.module("energis.ucet", [])
.config(function routes($stateProvider){
  $stateProvider
  .state("meradlo-list", {
    url: "/meradla",
    template: require("./meradlo.list.html"),
    controller: ListViewCtrl,
    controllerAs: "ctrl",
    resolve: {
      itemSource: MeradloService => MeradloService.listSource().wait()
    }
  })
  .state("meradlo-edit", {
    url: "/meradla/{id:int}/edit",
    template: require("./meradlo.edit.html"),
    controller: MeradloEditCtrl,
    controllerAs: "ctrl",
    resolve: {
      item: ($stateParams, MeradloService) => MeradloService.get($stateParams.id),
      saveHandler: (MeradloService) => (id, item) => MeradloService.save(id, item),
      stavMeradlaSource: (MeradloService, $stateParams) => MeradloService.stavSource($stateParams.id)
    }
  })
  .state("meradlo-import", {
    url: "/meradla/import",
    template: require("./meradlo.import.html"),
    controller: MeradloImportCtrl,
    controllerAs: "ctrl",
    resolve: {
      itemSource: (MeradloService) => MeradloService.importSource().wait()
    }
  })
})
.service("MeradloService", MeradloService)
.name;



// WEBPACK FOOTER //
// ./src/Meradlo/index.js